import React from "react";
import { Typography, Divider, useMediaQuery } from "@mui/material";
import "@fontsource/rubik/500.css";
import "@fontsource/rubik/400.css";
import ExpandInfo from "./ExpandInfo";

const Step8Casnic = () => {
  const isLaptop = useMediaQuery("(max-width: 1400px)");
  const isMobile = useMediaQuery("(max-width: 1024px)");

  return (
    <div>
      <div
        style={{
          display: "flex",
          alignItems: "flex-start",
          marginLeft: isMobile ? 0 : "140px",
          marginRight: isMobile ? -20 : "140px",
          marginTop: isMobile ? -50 : "50px",
        }}
      >
        {!isMobile ? (
          <Divider
            orientation="vertical"
            sx={{
              height: isLaptop ? "18rem" : "16rem",
              width: "4px",
              backgroundColor: "#29348f",
            }}
          />
        ) : (
          ""
        )}
        <div style={{ marginLeft: 34 }}>
          {isMobile ? (
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <div
                variant="contained"
                style={{
                  backgroundColor: "black",
                  textTransform: "none",
                  borderRadius: "20px 0px 0px 20px",
                  height: 40,
                  width: 90,
                  paddingLeft: 14,
                  paddingTop: 8,
                }}
              >
                <Typography variant="body1" color="white">
                  Furnizor
                </Typography>
              </div>
              <div
                variant="contained"
                style={{
                  backgroundColor: "#29348f",

                  textTransform: "none",
                  height: 40,
                  width: 80,
                  paddingLeft: 14,
                  paddingTop: 8,
                }}
              >
                <Typography variant="body1" color="white">
                  Client
                </Typography>
              </div>
            </div>
          ) : (
            <div style={{ display: "flex" }}>
              <div
                variant="contained"
                style={{
                  backgroundColor: "#29348f",
                  textTransform: "none",
                  height: 40,
                  width: 70,
                  paddingLeft: 14,
                  paddingTop: 8,
                }}
              >
                <Typography variant="body1" color="white">
                  Client
                </Typography>
              </div>
              <div
                variant="contained"
                style={{
                  backgroundColor: "black",
                  borderRadius: "0px 20px 20px 0px",
                  textTransform: "none",
                  height: 40,
                  width: 90,
                  paddingLeft: 14,
                  paddingTop: 8,
                }}
              >
                <Typography variant="body1" color="white">
                  Furnizor
                </Typography>
              </div>
            </div>
          )}
          <Typography variant="h6" sx={{ mt: 4 }}>
            Încheierea contractului de furnizare a energiei electrice
          </Typography>
          <Typography variant="body2" sx={{ mt: 2 }}>
            Pentru ca instalația de utilizare să fie pusă sub tensiune este
            necesar să încheiați contractul de furnizare de energie electrică cu
            un furnizor ales de dumneavoastră
          </Typography>
          <Typography variant="body2" sx={{ mt: 2 }}>
            DEER și personalul angajat al DEER nu au niciun fel de atribuții și
            nu se implică ȋn ceea ce privește alegerea de către clientul final a
            furnizorului de energie electrică. DEER se delimitează de orice
            tentativa de influențare a consumatorului ȋn procesul de alegere a
            unui furnizor de energie electrică.
          </Typography>
          {/* <Typography variant="h6" sx={{ mt: 4 }}>
            Cereri de încheiere a contractelor de racordare
          </Typography>

          <Typography variant="body2" sx={{ mt: 2 }}>
            Contract de execuție încheiat de către Solicitant direct cu un
            executant atestat ANRE
          </Typography>

          <Typography variant="body2" sx={{ mt: 0 }}>
            <a href="./Notificare-utilizator-incheiere-contract-cu-tert-Ordin-181.doc" style={{ color: "#0D6D92" }}>
              Notificare
            </a>
          </Typography>
          <Typography variant="body2" sx={{ mt: 2 }}>
            Cu licitație
          </Typography>

          <Typography variant="body2" sx={{ mt: 0 }}>
            <a href="./Cerere-incheiere-contract-de-racordare.doc" style={{ color: "#0D6D92" }}>
              Cerere de încheiere contract de racordare
            </a>
          </Typography>
          <Typography variant="body2" sx={{ mt: 2 }}>
            Cu atribuire
          </Typography>

          <Typography variant="body2" sx={{ mt: 0 }}>
            <a href="./Cerere-incheiere-contract-de-racordare-Ordin-18-1.doc" style={{ color: "#0D6D92" }}>
              Cerere de încheiere contract de racordare
            </a>
          </Typography>
          <Typography variant="body2" sx={{ mt: 0 }}>
            <a href="./Conventie-de-atribuire-DEER-14.doc" style={{ color: "#0D6D92" }}>
              Convenție de Atribuire DEER
            </a>
          </Typography>
          <Typography variant="body2" sx={{ mt: 0 }}>
            <a href="./Conventie-de-atribuire-Sucursala-17.doc" style={{ color: "#0D6D92" }}>
            Convenție de Atribuire Sucursală            
            </a>
          </Typography>


          <Typography variant="h6" sx={{ mt: 4 }}>
          Toate tipurile de solicitari, cu exceptia celor de la pct. 1          
          </Typography>

          <Typography variant="body2" sx={{ mt: 2 }}>
            Contract de execuție încheiat de către Solicitant direct cu un
            executant atestat ANRE
          </Typography>

          <Typography variant="body2" sx={{ mt: 0 }}>
            <a href="./Notificare.doc" style={{ color: "#0D6D92" }}>
              Notificare
            </a>
          </Typography>
          <Typography variant="body2" sx={{ mt: 2 }}>
            Cu licitație
          </Typography>

          <Typography variant="body2" sx={{ mt: 0 }}>
            <a href="./Cerere-incheiere-contract-de-racordare.doc" style={{ color: "#0D6D92" }}>
              Cerere de încheiere contract de racordare
            </a>
          </Typography>
          <Typography variant="body2" sx={{ mt: 2 }}>
            Cu atribuire
          </Typography>

          <Typography variant="body2" sx={{ mt: 0 }}>
            <a href="./Cerere-incheiere-contract-de-racordare-1.doc" style={{ color: "#0D6D92" }}>
              Cerere de încheiere contract de racordare
            </a>
          </Typography>
          <Typography variant="body2" sx={{ mt: 0 }}>
            <a href="./Conventie-de-atribuire-DEER.doc" style={{ color: "#0D6D92" }}>
              Convenție de Atribuire DEER
            </a>
          </Typography>
          <Typography variant="body2" sx={{ mt: 0 }}>
            <a href="./Conventie-de-atribuire-Sucursala.doc" style={{ color: "#0D6D92" }}>
            Convenție de Atribuire Sucursală
            </a>
          </Typography> */}

          {/* <Typography variant="body2" sx={{ mt: 2 }}>
            15 zile calendaristice de la înregistrarea cererii scrise
          </Typography> */}
        </div>
        {isMobile ? (
          <Divider
            orientation="vertical"
            sx={{
              height: "32rem",
              width: "4px",
              backgroundColor: "#29348f",
              ml: 2,
            }}
          />
        ) : (
          ""
        )}
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "flex-start",
          marginLeft: isMobile ? -30 : "140px",
          marginTop: "50px",
          marginRight: isMobile ? 0 : "140px",
          marginBottom: "60px",
        }}
      >
        <Divider
          orientation="vertical"
          sx={{
            height: "4rem",
            width: "4px",
            backgroundColor: "#29348f",
            mr: isMobile ? 3 : "",
          }}
        />
        <ExpandInfo />
      </div>
    </div>
  );
};

export default Step8Casnic;
